// The three-way match of a supplier invoice (procurement plan §2.9), in words. Differences
// are "attention" tags with the numbers behind them; nothing is coloured.
import type { InvoiceMatchView } from '@wodi/shared';
import { Cell, Column, Row, Table, TableBody, TableHeader, Tag } from '@wodi/ui';

import { TableScroll } from '../layout/screen.tsx';
import { formatCents } from '../stock/format.ts';
import styles from '../stock/stock.module.css';
import { matchLineWords } from './format.ts';
import local from './procurement.module.css';

export function MatchTable({ match }: { match: InvoiceMatchView }) {
  return (
    <>
      <TableScroll>
        <Table flat aria-label="Invoice against the LPO and goods received">
          <TableHeader>
            <Column isRowHeader>Item</Column>
            <Column numeric>Packs</Column>
            <Column numeric>Invoice price</Column>
            <Column numeric>LPO price</Column>
            <Column numeric>Line total</Column>
            <Column numeric>Difference</Column>
            <Column>Match</Column>
          </TableHeader>
          <TableBody items={match.lines.map((l) => ({ ...l, id: l.lineNo }))}>
            {(l) => (
              <Row id={l.lineNo}>
                <Cell>{l.itemName}</Cell>
                <Cell numeric>
                  {l.packs} × {l.packUnitDisplay}
                </Cell>
                <Cell numeric>{formatCents(l.packPrice.cents)}</Cell>
                <Cell numeric>{formatCents(l.orderPackPrice.cents)}</Cell>
                <Cell numeric>{formatCents(l.lineTotal.cents)}</Cell>
                <Cell numeric>
                  {l.difference.cents === '0' ? '' : formatCents(l.difference.cents)}
                </Cell>
                <Cell>
                  <ul className={local.flags}>
                    {matchLineWords(l).map((words) => (
                      <li key={words}>
                        <Tag state={l.flags.length === 0 ? 'done' : 'attention'}>{words}</Tag>
                      </li>
                    ))}
                  </ul>
                </Cell>
              </Row>
            )}
          </TableBody>
        </Table>
      </TableScroll>
      <p className={styles.meta}>
        Lines {formatCents(match.linesTotal.cents)}; with VAT the total should be{' '}
        {formatCents(match.expectedTotal.cents)}.
        {match.totalMismatch ? ' The printed total is different: check it with the supplier.' : ''}
      </p>
    </>
  );
}
